import React from 'react';
import { convertNodeDataToDraft } from 'ricos-content/libs/convertNodeDataToDraftNoInnerRCE';
import { camelCase, isFunction } from 'lodash';
import { g as getContainerClassNames, s as styles } from '../../../../getClassNames-0aacfa6c.js';
import Anchorable from '../../utils/Anchorable.js';
import { ContainerElement } from './ContainerElement.js';
import 'classnames';
import 'wix-rich-content-common';
import '../../utils/paywallSeo.js';
import 'ricos-context';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Plugin = ({
  pluginComponent: { component: Component, classNameStrategies, withHorizontalScroll },
  type,
  context,
  node,
  nodeIndex,
  SpoilerViewerWrapper,
  children
}) => {
  var _a, _b, _c, _d;
  const dataProperty = `${camelCase(node.type)}Data`;
  const draftComponentData = convertNodeDataToDraft(node.type, node[dataProperty]);
  const settings = ((_a = context.config) == null ? void 0 : _a[type]) || {};
  const { theme, isMobile } = context;
  const componentProps = __spreadProps(__spreadValues({
    type,
    componentData: draftComponentData,
    settings,
    children
  }, context), {
    blockKey: node.id
  });
  const { container } = classNameStrategies || {};
  const containerClassName = getContainerClassNames(
    node,
    draftComponentData,
    theme,
    isMobile,
    classNameStrategies,
    withHorizontalScroll
  );
  const ContainerComponent = /* @__PURE__ */ React.createElement(
    ContainerElement,
    {
      className: containerClassName,
      node,
      nodeIndex,
      context
    },
    isFunction(container) ? /* @__PURE__ */ React.createElement("div", { className: container(context.theme) }, /* @__PURE__ */ React.createElement(Component, __spreadValues({}, componentProps))) : /* @__PURE__ */ React.createElement(Component, __spreadValues({}, componentProps))
  );
  const width = (_d = (_c = (_b = node[dataProperty]) == null ? void 0 : _b.containerData) == null ? void 0 : _c.width) == null ? void 0 : _d.custom;
  return /* @__PURE__ */ React.createElement(Anchorable, { nodeId: node.id }, /* @__PURE__ */ React.createElement("div", { className: styles.atomic }, SpoilerViewerWrapper ? /* @__PURE__ */ React.createElement(
    SpoilerViewerWrapper,
    __spreadValues({
      className: containerClassName,
      width: width ? parseInt(width) : void 0
    }, componentProps),
    ContainerComponent
  ) : ContainerComponent));
};
const fromTypeMapper = (args) => {
  return ({ node, nodeIndex }) => {
    return /* @__PURE__ */ React.createElement(Plugin, __spreadValues({ key: node.id, node, nodeIndex }, args));
  };
};

export { fromTypeMapper };
//# sourceMappingURL=fromTypeMapper.js.map
